"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTimeoutError = exports.createTimeoutError = void 0;

var isTimeoutError = function isTimeoutError(e) {
  return e && e.name === 'TimeoutError';
};

exports.isTimeoutError = isTimeoutError;

var createTimeoutError = function createTimeoutError(message) {
  var error = new Error(message);
  error.name = 'TimeoutError';
  return error;
};

exports.createTimeoutError = createTimeoutError;